import buildSubjectApiPath from '@Application/Subjects/buildSubjectApiPath';
import type * as React from 'react';
import workflowRunOpened, {
	type WorkflowRunOpenedAction,
} from '@Application/WorkflowRuns/WorkflowRun/Actions/workflowRunOpened';
import workflowRunOpeningFailed, {
	type WorkflowRunOpeningFailedAction,
} from '@Application/WorkflowRuns/WorkflowRun/Actions/workflowRunOpeningFailed';
import type OpenWorkflowRun from '@Application/WorkflowRuns/WorkflowRun/Commands/OpenWorkflowRun';
import type { WorkflowRunPayload } from '@Application/WorkflowRuns/WorkflowRun/Actions/workflowRunFetched';
import { post } from '@Domain/Api';
import extractMessages from '@Infra/FetchLib/ApiError/extractMessages';

type Actions = WorkflowRunOpenedAction | WorkflowRunOpeningFailedAction;

/** `201` with the new run. */
export default (command: OpenWorkflowRun) => {
	return async (dispatch: React.Dispatch<Actions>): Promise<Actions> => {
		try {
			const payload = await post<WorkflowRunPayload>(
				`${buildSubjectApiPath(command.facilityId, command.subject)}/workflow-runs`,
				command.toJSON(),
			);

			const action = workflowRunOpened(
				payload,
				command.facilityId,
				command.subject.typeKey,
				command.subject.subjectId,
			);
			dispatch(action);
			return action;
		} catch (error) {
			const action = workflowRunOpeningFailed(extractMessages(error));
			dispatch(action);
			return Promise.reject(action);
		}
	};
};
